// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3arUR","inputWrap":"CustomTip_inputWrap__1gq4v"};